module.exports = __webpack_public_path__ + "assets/img/second.23dac352.png";